module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-7.e9eff0fb.png";